import axios from 'axios';

const LOGIN_API_URL = `${process.env.REACT_APP_API_BASE_URL}/login.php`;

const TOKEN_KEY = 'auth_token';
const USER_KEY  = 'auth_user';

const authService = {

  /**
   * Stores token and username after successful login.
   */
  saveCredentials(token, username) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, username);
  },

  /**
   * Returns the stored token (or null).
   */
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Returns the stored username.
   */
  getUsername() {
    return localStorage.getItem(USER_KEY);
  },

  /**
   * Removes all stored auth data.
   */
  clearCredentials() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  /**
   * Checks with the server whether the stored token is still valid.
   * Returns { authenticated, username }.
   */
  async checkSession() {
    const token = authService.getToken();
    try {
      const response = await axios.get(LOGIN_API_URL, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return response.data; // { authenticated: bool, username? }
    } catch {
      return { authenticated: false };
    }
  },

  /**
   * Logs the user in.
   * Throws an error if login fails.
   */
  async login(username, password) {
    const response = await axios.post(
      LOGIN_API_URL,
      { username, password },
      { headers: { 'Content-Type': 'application/json' } }
    );
    // response.data = { token, username }
    authService.saveCredentials(response.data.token, response.data.username);
    return response.data;
  },

  /**
   * Logs the user out and clears local storage.
   */
  async logout() {
    const token = authService.getToken();
    authService.clearCredentials();
    if (token) {
      try {
        await axios.delete(LOGIN_API_URL, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch {
      // Ignore server-side logout error – local data already cleared
      }
    }
  },
};

export default authService;
